<template>
    <!-- 选择身份 -->
    <div class="auth-identity page-back">
        <div class="identity-card">
            <div class="identity-card-title font-32 text-center font-bold">
                您的身份是？
            </div>
            <div
                class="identity-card-title-auxiliary text-center font-bold font-24"
            >
                同是车主和驾驶员请选择车主身份
            </div>
            <div class="identity-list flex flex-center">
                <div
                    class="identity-item "
                    v-for="item in identityData"
                    :key="item.id"
                >
                    <div
                        class="identity-item-box"
                        @click="identityChange(item)"
                    >
                        <div class="img-box">
                            <img
                                class="identity-item-img"
                                :src="item.iconLink"
                            />
                            <img
                                :src="
                                    item.is_active ? iconSelect : iconUnSelect
                                "
                                class="select-img"
                            />
                        </div>
                        <div class="name text-center font-bold font-24">
                            {{ item.identity }}
                        </div>
                    </div>
                </div>
                <div
                    class="other flex flex-center flex-vertical-center"
                    @click="otherChange"
                >
                    <img :src="otherData | selectImg" />
                    <div>{{ otherData.identity }}</div>
                </div>
            </div>
        </div>
        <footer class="footer">
            <div class="footer-title text-center font-24">
                请准确选择身份，以便为您提供更好服务
            </div>
            <footer-button
                :isHabitation="false"
                @config="showConfirmDialog"
                btnText="确认"
            />
        </footer>
        <van-action-sheet
            :close-on-click-overlay="false"
            :safe-area-inset-bottom="true"
            :class="{ 'safe-area-inset-bottom': safeAreaInset }"
            v-model="showActionSheet"
            :round="false"
            :actions="actionsData"
            @select="onSelectSheet"
        />
        <confirm-dialog
            :title="'请再次核实身份'"
            :cancelButtonText="'修改'"
            :confirmButtonText="'确定'"
            message="注：您后续可以在个人中心完成认证"
            @confirm="confirmBtn"
            ref="ConfirmDialog"
        >
        </confirm-dialog>
    </div>
</template>

<script>
import FooterButton from '@/components/Button/FooterButton'
import IconSelect from '@/assets/images/attestation/select.png'
import IconUnSelect from '@/assets/images/attestation/unselect.png'
import ConfirmDialog from '@/components/dialog/ConfirmDialog'
import ajax from '@/api/index'
import Vue from 'vue'
import { Toast } from 'vant'
import utils from '@/utils/index'

export default {
    props: {},
    data() {
        return {
            identityData: [],
            select_id: null, // 选择的身份id
            select_pid: null, // 选择的身份子pid
            otherData: {
                id: 7,
                identity: '其他身份',
                iconLink: null,
                is_active: false
            },
            actionsData: [], // 二级目录显示的数据
            showActionSheet: false, // 上拉菜单是否显示
            iconSelect: IconSelect,
            iconUnSelect: IconUnSelect
        }
    },
    computed: {},
    components: {
        FooterButton,
        ConfirmDialog
    },
    created() {
        document.title = '身份选择'
    },
    watch: {},
    filters: {
        /**
         *
         *
         * 过滤选择的图片
         */
        selectImg(item) {
            return item.is_active ? IconSelect : IconUnSelect
        }
    },
    methods: {
        async init() {
            try {
                const { code, data } = await ajax.getIdentityInfo()
                if (code === 200) {
                    const {
                        identities,
                        currentIdentityId,
                        currentParentIdentityId
                    } = data
                    this.select_id =
                        currentIdentityId === 0 ? null : currentIdentityId
                    this.currentParentIdentityId =
                        currentParentIdentityId === 0
                            ? currentIdentityId
                            : currentParentIdentityId
                    this.identityData = identities
                        .map((item, index) => {
                            const _item = {
                                ...item,
                                is_active:
                                    (this.currentParentIdentityId !== 0 &&
                                    item.id === this.currentParentIdentityId)
                            }
                            Vue.set(item, index, _item)
                            return _item
                        })
                        .filter(item => item.id !== 7)
                    this.otherData.is_active = currentIdentityId === 7
                }
            } catch (error) {
                // 错误信息
            }
        },
        /**
         * @param children 子菜单
         * @param id 选取的身份id
         * 身份选择change事件
         */
        identityChange({ id, children }) {
            this.otherData.is_active = false
            if (children.length) {
                this.showActionSheet = true
                this.actionsData = children.map(item => {
                    return {
                        ...item,
                        name: item.identity
                    }
                })
            } else {
                this.select_id = id
                this.identityData.forEach(item => {
                    item.is_active = item.id === id
                })
            }
            this.select_pid = id
        },
        /**
         * @param id 选取的身份id
         * 上拉菜单选择弹框
         */
        onSelectSheet({ id }) {
            this.select_id = id
            let name = ''
            this.actionsData.forEach(ele => {
                if (ele.id === id) {
                    name = ele.identity
                }
            })
            this.identityData.forEach(item => {
                item.is_active = item.id === this.select_pid
                if (item.id === this.select_pid) {
                    item.identity = name
                }
            })
            this.showActionSheet = false
            this.actionsData = []
        },
        /**
         * 选择其他身份
         */
        otherChange() {
            this.select_id = 7
            this.otherData.is_active = true
            this.identityData.forEach(item => {
                item.is_active = false
            })
        },
        showConfirmDialog() {
            if (!this.select_id) {
                Toast('请先勾选身份')
                return
            }
            this.$refs.ConfirmDialog.showPopup()
        },
        /**
         *
         *
         * 确定选择身份
         */
        async confirmBtn() {
            try {
                const { select_id } = this
                const { code } = await ajax.updateIdentityInfo({
                    identityId: select_id
                })
                if (code === 200) {
                    if (this.isWechart) {
                        let { userCenter = 0 } = this.$route.query
                        userCenter = Number(userCenter)
                        if (userCenter === 0) {
                            utils.wxNavigateBack(1)
                        } else {
                            utils.wxRedirectTo(
                                '/pages-user-center/authentication/index'
                            )
                        }
                    } else {
                        // 安卓和苹果客户端
                        window.location.href =
                            'https://www.success.selectidentity/'
                    }
                }
            } catch (error) {
                // 错误信息
            }
        }
    },
    mounted() {
        this.init()
    }
}
</script>

<style scoped lang="scss">
.auth-identity {
    padding-top: 30px;
    .identity-card {
        background-color: #ffffff;
        padding: 40px 78px;
        .identity-card-title-auxiliary {
            color: #5277fd;
            padding: 10px 0 60px;
        }
    }
    .identity-list {
        margin-top: 30px;
        flex-wrap: wrap;
        .identity-item {
            width: 50%;
            margin-bottom: 20px;
            .identity-item-box {
                .img-box {
                    width: 140px;
                    height: 140px;
                    border-radius: 50%;
                    margin: 0px auto;
                    position: relative;
                    .identity-item-img {
                        width: 80px;
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                    }
                    .select-img {
                        width: 30px;
                        position: absolute;
                        bottom: 4px;
                        right: 4px;
                    }
                }
            }
            &:nth-child(1) {
                .identity-item-box {
                    .img-box {
                        background-color: #ffe5dc;
                    }
                }
            }
            &:nth-child(2) {
                .identity-item-box {
                    .img-box {
                        background-color: #ffefdc;
                    }
                }
            }
            &:nth-child(3) {
                .identity-item-box {
                    .img-box {
                        background-color: #d3f9e5;
                    }
                }
            }
            &:nth-child(4) {
                .identity-item-box {
                    .img-box {
                        background-color: #dbe3ff;
                    }
                }
            }
            .name {
                color: #282828;
                padding-top: 20px;
            }
        }
        .other {
            margin-top: 40px;
            img {
                width: 30px;
                height: 30px;
            }
            div {
                padding-left: 20px;
                color: #282828;
                font-size: 24px;
                font-weight: bold;
            }
        }
    }

    .footer {
        position: fixed;
        left: 0;
        bottom: 0;
        .footer-title {
            color: #9b9b9b;
            padding-bottom: 20px;
        }
    }
}
</style>
